import {forbidden_emails } from "./forbidden-emails.js";

/*
 * Javascript for the get-started.blade.php page
 */

/*
 * @NOTE(Grey): References
 * - hubspot cookies: https://knowledge.hubspot.com/reports/what-cookies-does-hubspot-set-in-a-visitor-s-browser
 * - hubspot form submissions: https://app.hubspot.com/forms/1842135/bc7cf6c8-b7b5-4a3e-99cd-c4152ed8cb6e/submissions/416a67ee-7af1-48d5-8c58-12d908707f98
 * - submit data to a form via the api: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 * - forms api overview: https://legacydocs.hubspot.com/docs/methods/forms/forms_overview
 * - test form: https://share.hsforms.com/1vHz2yLe1Sj6ZzcQVLtjLbg13hef
 * - email regex: https://stackoverflow.com/a/201378/13305905
 */

let step_index = 0;
let forms = [
    document.getElementById('js-step00'),
    document.getElementById('js-step01'),
    document.getElementById('js-step02')
];

function domain_and_tld(email) {
    let domain_start = email.indexOf('@') + 1;
    let domain = email.substr(domain_start);
    let tld_start = domain.indexOf('.') + 1;
    let tld = domain.substr(tld_start);

    return { "domain": domain, "tld": tld };
}


// @NOTE(Grey): There is one potential foible, if invalidate a field, and then
// go and fix it, once it is fixed the error will go away, however you can
// continue to "fix" it and break it again, the error will not show up until
// you blur the field again

function fields_valid(step_index, steps, event) {
    let step = steps[step_index];
    let button = null;
    let valid = true;
    let error_fields = [];

    for (let i = 0; i < step.length; ++i) {
        // @NOTE(Grey): We don't want to touch hidden fields at all, at least
        // on this form currently
        if (step[i].type === 'hidden') {
            continue;
        }

        // @NOTE(Grey): Cache error fields
        if (typeof(error_fields[i]) == 'undefined') {
            // @TODO(Grey): This is super brittle, I should probably do this
            // with a proper selector instead
            let error_container = null;
            if (step[i].type === 'select-one') {
                // @NOTE(Grey): If it's a select element
                error_container = step[i].parentElement.parentElement;
            } else {
                error_container = step[i].parentElement;
            }

            if (error_container) {
                error_fields[i] = error_container;
            }
        }

        if (step[i].tagName === 'BUTTON') {
            if (!button) {
                button = step[i];
            }
            continue;
        }

        if (step[i].type === 'email') {
            let infos = domain_and_tld(step[i].value);
            if (infos.tld.length > 1) {
                for (let i = 0; i < forbidden_emails.length; ++i) {
                    if (forbidden_emails[i] == infos.domain) {
                        valid = false;
                    }
                }
            } else {
                valid = false;
            }
        } else if (step[i].type === 'checkbox') {
            if (!step[i].checked) {
                valid = false;
            }
        } else if (step[i].id === 'company') {
            if (step[i].value.length === 0) {
                valid = false;
            } else if (step[i].value.length < 3) {
                valid = false;
            }
        } else {
            if (!step[i].value) {
                valid = false;
            }
        }

        if (valid) {
            $(error_fields[i]).addClass('is-valid');
        }
    }

    if (valid && button) {
        button.removeAttribute("disabled");
    } else if (button) {
        button.setAttribute("disabled", true);
    }

    return valid;
}

function fields_errors(field) {
    let valid = true;
    let error_message = null;

    if (field.type === 'email') {
        error_message = "This field is required";
        let infos = domain_and_tld(field.value);
        if (infos.tld.length > 1) {
            for (let i = 0; i < forbidden_emails.length; ++i) {
                if (forbidden_emails[i] == infos.domain) {
                    valid = false;
                    error_message = "Please enter your work email address. No work email? Contact us at info@jostle.me";
                }
            }
        } else {
            valid = false;
            error_message = "Please enter your work email address. No work email? Contact us at info@jostle.me";
        }
    } else if (field.type === 'checkbox') {
        valid = field.checked;
    } else if (field.id === 'company') {
        if (field.value.length == 0) {
            valid = false;
            error_message = "This field is required";
        } else if (field.value.length < 3) {
            valid = false;
            error_message = "Company name must be 3 or more characters";
        }
    } else {
        valid = field.value;
    }

    if (!valid) {
        let error_container = null;
        if (field.type === 'select-one') {
            error_container = field.parentElement.parentElement;
        } else {
            error_container = field.parentElement;
        }

        if (error_container) {
            $(error_container).removeClass('is-valid');
        }

        if (error_message && error_container) {
            $(error_container)
                .find('.FormField-error')
                .text(error_message);
        }
    }
}

function get_hbspt_utk_cookie() {
    let index_hbspt_utk = document.cookie.indexOf('hubspotutk');

    if (index_hbspt_utk === -1) {
        return false;
    }

    let index_equals    = document.cookie.substr(index_hbspt_utk).indexOf('=');
    let index_semicolon = document.cookie.substr(index_hbspt_utk).indexOf(';');

    let utk_start = index_hbspt_utk + index_equals + 1;
    let utk_end   = index_semicolon - index_equals - 1;

    let utk = document.cookie.substr(utk_start, utk_end);

    return utk;
}

function submit_form(fields) {
    let PORTAL_ID = '1842135';
    let FORM_GUID = 'bc7cf6c8-b7b5-4a3e-99cd-c4152ed8cb6e';

    let xhr = new XMLHttpRequest();
    let url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_GUID;
    let utk = get_hbspt_utk_cookie();

    let page_ctx = {};

    if (utk) {
        page_ctx.hutk = utk;
    }

    page_ctx.pageUri = document.location.href;
    page_ctx.pageName = document.title;

    let data = {
        "fields": fields,
        "context": page_ctx,
        "legalConsentOptions": {
            "consent": {
                "consentToProcess": true,
                "text": "Jostle needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy.",
            }
        }
    };

    let data_encoded = JSON.stringify(data)

    /*
    * @TODO(Grey):
    * - If the form is properly submitted move on to the next step
    * - Show an error message if the form was unable to be submitted
    */
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            // @NOTE(Grey): Succeeded
            step_index++;
            $(window).trigger("stepchange", [step_index]);
        } else if (xhr.readyState === 4 && xhr.status === 400) {
            console.warn('Submission rejected ', xhr.responseText);
            $('.js-FormSubmitError')
                .addClass('is-visible')
                .text('Submission rejected');
        } else if (xhr.readyState === 4 && xhr.status === 403) {
            console.warn('Portal cannot post submissions ', xhr.responseText);
            $('.js-FormSubmitError')
                .addClass('is-visible')
                .text('Portal cannot post submissions');
        } else if (xhr.readyState === 4 && xhr.status === 404) {
            console.warn('Form GUID is not found ', xhr.responseText);
            $('.js-FormSubmitError')
                .addClass('is-visible')
                .text('Form GUID is not found');
        }
    }

    xhr.send(data_encoded);
}

function submit_handler(steps, event) {
    event.preventDefault();

    let fields = [];

    if (step_index === steps.length - 1) {
        for (let c = 0; c < steps.length; ++c) {
            let step = steps[c];
            for (let i = 0; i < step.length; ++i) {
                if (step[i].tagName === 'BUTTON') {
                    continue;
                }

                if (step[i].type === 'checkbox') {
                    fields.push({"name": step[i].id, "value": step[i].checked });
                } else {
                    fields.push({"name": step[i].id, "value": step[i].value });
                }
            }
        }

        submit_form(fields);
    }
    else
    {
        step_index++;
        $(window).trigger("stepchange", [step_index]);

        if (steps[0].email.value) {
            window.enhanced_conversion_data = {
                "email": steps[0].email.value
            };
        }
    }
}

$(document).ready(function() {
    // @NOTE(Grey): If this class isn't on the page we are probably not on the right page
    if (!$('.js-Step').length) {
        return;
    }

    // @NOTE(Grey): If you navigate away from the page and then hit the back
    // button Chrome(?) re-populates your form on load, I need to check if
    // this happened and activate the buttons if it did
    $(window).on('load', function() {
        for (let i = 0; i < forms.length; ++i) {
            fields_valid(i, forms);
        }
    });

    $(window).on('stepchange', function(event, index) {
        // @NOTE(Grey): `$(steps)` is for the forms,`$('.js-Step')` is for the panels
        $(forms)
            .addClass('is-hidden');
        $(forms[index])
            .removeClass('is-hidden');

        $('.js-Step')
            .addClass('is-hidden');
        $('.js-Step')
            .eq(index)
            .removeClass('is-hidden');

        // @TODO(Grey): Re-do this so it's not just an image change (animated etc.)
        $('.js-StepVis')
            // @NOTE(Grey): This is taken from a stack overflow post:
            // https://stackoverflow.com/a/5182103/13305905
            .removeClass(function(index, className) {
                return (className.match(/(^|\s)StepVis--\S+/g) || []).join(' ');
            });
        $('.js-StepVis')
            .addClass('StepVis--0' + (index + 1));
    });


    for (let i = 0; i < forms.length; ++i) {
        let $step = $(forms[i]);

        $step.on('submit', submit_handler.bind(this, forms));

        $step.on('focusin', function() {
            $step.on('keyup', fields_valid.bind(this, i, forms));
            $step.on('change', fields_valid.bind(this, i, forms));
        });

        $step.on('focusout', function(event) {
            $step.off('keyup', fields_valid);
            $step.off('change', fields_valid);

            fields_errors(event.target);
        });
    }

    $('.js-NoProblem').on('click', function(event) {
            event.preventDefault();

            // @TODO(Grey): Clean this up from being super haxx
            $('.Step')
                .eq(3)
                .addClass('is-hidden')

            $('.Step')
                .eq(4)
                .removeClass('is-hidden')

            $('.js-StepVis')
                // @NOTE(Grey): This is taken from a stack overflow post:
                // https://stackoverflow.com/a/5182103/13305905
                .removeClass(function(index, className) {
                    return (className.match(/(^|\s)StepVis--\S+/g) || []).join(' ');
                });
            $('.js-StepVis')
                .addClass('StepVis--05');
        });
});